import { FormHelperText } from '@mui/material';
import Skeleton from '../../inputs/Skeleton';
import tid from '@/common/infrastructure/config/tid';

export function FormikFieldSkeleton() {
  return (
    <>
      <Skeleton {...tid('common:formik-field-skeleton:skeleton')} />
      <FormHelperText>&nbsp;</FormHelperText>
    </>
  );
}
